import env from '../../config/env';
import React, { useState, useEffect } from 'react';
import { ToastProvider, useToasts } from 'react-toast-notifications';
import { useAppDispatch } from '../../redux/store/hooks';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import background from '../../assets/img/header.jpg';
import language from '../../config/es';
import { Amplify, I18n, Auth, Hub } from 'aws-amplify';
import awsConfig from '../../aws-exports';
import './management.scss';
import { useSinTema } from '../../shared/theme/ThemeProvider';
import {logInUserData} from '../../redux/login.duck';
import Button from '../../shared/ui/Button/Button';
import Lottie from "lottie-react";
import loadingAD from "../../assets/json/load-fragmented-square.json";
import income from "../../assets/json/income.json";

Amplify.configure(awsConfig);
I18n.setLanguage('es');

const Login = () => {
  useSinTema();
  const { addToast, removeAllToasts } = useToasts();
  const dispatch = useAppDispatch();
  const [data, setData] = useState({
    disable: false,
    user: null,
    menu: null,
    module: null,
    node: null,
    enable: true
  });
  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value
    });
  };

  const [dataLoad, setDataLoad] = useState({
    showLoading: false
  });
  const updateStateLoad = (value, id) => {
    setDataLoad({
      ...dataLoad,
      [id]: value
    });
  };
  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn':
          viewNotification(language.messages.loginADSuccessAwait,'success');
          updateStateLoad(true, "showLoading");
          break;
        case 'cognitoHostedUI':
          void handleSubmit();
          break;
        case 'signIn_failure':
          updateStateLoad(false, "showLoading");
          break;
        case 'cognitoHostedUI_failure':
          updateStateLoad(false, "showLoading");
          break;
        default:
          break;
      }
    });

  });
  const viewNotification = (msm, action) => {
    removeAllToasts();
    addToast(msm, {
      appearance: action,
      autoDismiss: true,
    });
  };

  const handleSubmit = async () => {
    try {
      updateState(false,"enable");
      let user = await dispatch(logInUserData());
      
      if (!user) {
        updateState(true,"enable");
        viewNotification(
          language.messages.loginUsernameExistError + '1',
          'error'
        );
        updateStateLoad(false, "showLoading");
      } else {
        const errorSession = JSON.parse(sessionStorage.getItem("errorSession"));
        if(errorSession === null) {
          viewNotification(language.messages.login.message_login_success,'success');
          window.location.href = '/src/home';
        } else {
          resetLogin();
          viewNotification(errorSession.error,'warning');
        }
      }
    } catch (e) {
      viewNotification(e.message, 'error');
      resetLogin();
    }
  };

  const resetLogin = () => {
    updateState(true,"enable");
    updateStateLoad(false, "showLoading");
    setTimeout(() => {
      Auth.signOut().catch((error) => console.log(error));
    }, 2000);
  }

  return (
    <Grid container component="main" style={{ height: '100vh' }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={6}
        style={{
          backgroundImage: 'url(' + background + ')',
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'white',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <Grid item xs={12} sm={8} md={6} component={Paper} elevation={6} square>
        <div className="login-panel">
            {!dataLoad.showLoading?
              <div className="title-header-animation">
                <Lottie animationData={income} />
                <h5>{language.messages.title_system}</h5>
              </div>: ""
            }
            {!dataLoad.showLoading?<div className="row my-3 d-flex justify-content-center">
            <Button
              kind="primary"
              icon="login"
              className="login-submit"
              onClick={() => Auth.federatedSignIn({ provider: env.cognito.adProvider })}
            >
              {language.messages.login.lbl_sign_in}
            </Button>
          </div>: <div className="login-panel">
            <Lottie animationData={loadingAD} />;
          </div>}
        </div>
      </Grid>
    </Grid>
  );
};

const App = () => (
  <ToastProvider>
    <Login />
  </ToastProvider>
);
export default App;
